












import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BasePlaceholder from '../BasePlaceholder.vue';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		BasePlaceholder,
	},
});
